import request from '@/utils/request'
import axios from 'axios'

const MAX_IMAGE_BYTES = 1048576

export function validateImageFile(file) {
  if (!file) {
    return 'Please select an image file.'
  }
  if (file.size > MAX_IMAGE_BYTES) {
    return 'File size must be 1MB or less.'
  }
  const allowed = ['image/png', 'image/jpeg', 'image/jpg']
  if (file.type && !allowed.includes(file.type)) {
    return 'Allowed file types: png, jpg, jpeg.'
  }
  return null
}

export function createTeam(teamName) {
  return request({ url: 'vcreateteam', method: 'post', data: { teamName } })
}

export function updateTeam(teamName) {
  return request({ url: 'vupdateteam', method: 'post', data: { teamName } })
}

export function setCoverPreference(coverSource) {
  return request({ url: 'vsetcoverpreference', method: 'post', data: { coverSource } })
}

export function setMemberTeam(teamId) {
  return request({ url: 'vsetmemberteam', method: 'post', data: { teamId } })
}

export function uploadTeamImage(type, file) {
  const formData = new FormData()
  formData.append('file', file)
  return axios.post(
    process.env.VUE_APP_BASE_API + 'uploadecimage?type=' + encodeURIComponent(type),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'ECAPP-TWXHEADER': localStorage.getItem('ecmtctoken')
      }
    }
  )
}

export function getPendingTeamCovers() {
  return request({ url: 'vteamcoverspending', method: 'get' })
}

export function reviewTeamCover(teamId, action) {
  return request({ url: 'vreviewteamcover', method: 'post', data: { teamId, action } })
}
